
import React from 'react';
import { Link } from 'react-router-dom';
import DefaultData from '../../CompanyData/DefaultData'; // Adjust path if needed

const FlightTabs = (props) => {
  const baseTabStyle = {
    border: 'none', fontWeight: '500', padding: '0.75rem 1.5rem',
    borderRadius: '0.375rem 0.375rem 0 0',
  };
  const inactiveTabStyle = { ...baseTabStyle, backgroundColor: 'transparent', color: DefaultData.THEMECOLOR3, opacity: 2, };
  const activeTabStyle = { ...baseTabStyle, backgroundColor: DefaultData.THEMECOLOR2, color: DefaultData.THEMECOLOR3, };
  const getStyle = (pageName) => (props.pageName === pageName ? activeTabStyle : inactiveTabStyle);

  return (
    <div style={{ backgroundColor: DefaultData.THEMECOLOR5, padding: '0 1rem', borderBottom: `1px solid ${DefaultData.THEMECOLOR2}` }}>
      <ul className="nav nav-tabs" style={{ borderBottom: 'none' }}>
        <li className="nav-item" role="presentation">
            <Link to={"/flight/search"} className="nav-link" style={getStyle("SEARCH")}>SEARCH</Link>
        </li>
        <li className="nav-item" role="presentation">
            <Link to={"/flight/bookings"} className="nav-link" style={getStyle("FLIGHTBOOKING")}>BOOKINGS</Link>
        </li>
        <li className="nav-item" role="presentation">
            <Link to={"/groupbookings"} className="nav-link" style={getStyle("GROUPFLIGHT")}>GROUP BOOKINGS</Link>
        </li>
        {/* <li className="nav-item" role="presentation">
            <Link to={"/flightreport"} className="nav-link" style={getStyle("FLIGHTREPORT")}>FLIGHT REPORT</Link>
        </li> */}
        <li className="nav-item" role="presentation">
            <Link to={"/flightsupplierreport"} className="nav-link" style={getStyle("SUPPLIERREPORT")}>SUPPLIER REPORT</Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/seriesfare/agent-search"} className="nav-link" style={getStyle("AGENT SEARCH")}>
            SEARCH SERIES FARE   
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/tools/voucher-gen"} className="nav-link" style={getStyle("VOUCHERGENERATOR")}>
            MANUAL VOUCHER    
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default FlightTabs;